import { Get, PostJson, PostJsonTyped } from "./ApiUtils";

const API_URL = "/api/work/";

export function GetWorkItemStatus(workItemId:string){
    return PostJsonTyped<IWorkItemStatus>(API_URL + "GetWorkItemStatus", workItemId)
}

export function GetUserName() {
    return Get(API_URL + "GetUserName").then(x => x.text());
}

export function GetPortalTasks(taskIds: string[]) {
    return PostJsonTyped<IPortalTaskDTO[]>(API_URL + "GetPortalTasks", taskIds);
}

export function GetPortalTasksForUser() {
    return PostJsonTyped<IPortalTaskDTO[]>(API_URL + "GetPortalTasksForUser");
}

export function GetPortalTasksByTag(uid: string, tag: string) {
    return PostJsonTyped<IPortalTaskDTO[]>(API_URL + "GetPortalTasksByTag", {
        Tag:tag,
        UserId:uid
    });
}

export function GetPortalTasksByKey(p:IGetTasksByKeyRequest) {
    return PostJsonTyped<IPortalTaskDTO[]>(API_URL + "GetPortalTasksByKey", p);
}

export function GetCompletedPortalTasksForUser() {
    return PostJsonTyped<IPortalTaskDTO[]>(API_URL + "GetCompletedPortalTasksForUser");
}

export function GetCardProjectionsForUser() {
    return PostJsonTyped<ITaskCardProjectionDTO[]>(API_URL + "GetCardProjectionsForUser");
}